import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { fileUrl } from "@/components/erp/prod/ProdInputs";

export const err = (e) => toast.error(e?.response?.data?.detail || "Gagal");
const CHUNK = 4 * 1024 * 1024;

export const uploadFlow = async (file) => {
  const id = Math.random().toString(36).slice(2) + Date.now().toString(36);
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let data;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", id); fd.append("index", i); fd.append("total", total); fd.append("filename", file.name);
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
    ({ data } = await api.post("/flow/upload-chunk", fd, { headers: { "Content-Type": "multipart/form-data" } }));
  }
  return data;
};

export const useFlow = (step) => {
  const [d, setD] = useState(null);
  const [denied, setDenied] = useState(false);
  const load = useCallback(() => api.get(`/flow/board?step=${step}`).then(({ data }) => setD(data)).catch((e) => { if (e?.response?.status === 403) setDenied(true); else err(e); }), [step]);
  useEffect(() => { load(); }, [load]);
  return { d, load, denied };
};

export const Thumbs = ({ paths = [], testid }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={testid}>
    {paths.map((p) => /\.(mp4|mov|webm|m4v)$/i.test(p)
      ? <video key={p} src={fileUrl(p)} className="w-20 h-20 rounded-lg object-cover border" controls />
      : <a key={p} href={fileUrl(p)} target="_blank" rel="noreferrer"><img src={fileUrl(p)} alt="" className="w-20 h-20 rounded-lg object-cover border" /></a>)}
  </div>
);

export const WoHead = ({ w, children }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`flow-wo-${w.wo_code}`}>
    <div className="flex flex-wrap items-start justify-between gap-2">
      <div>
        <div className="font-head font-bold text-lg">{w.wo_code} <span className="text-xs font-normal px-2 py-0.5 rounded-full bg-slate-100 align-middle">{w.level_label || w.step || w.waiting}</span></div>
        <div className="text-sm text-slate-600">{[w.product, w.customer, w.deadline && `deadline ${w.deadline}`].filter(Boolean).join(" · ")}</div>
        {w.notes && <div className="text-xs text-amber-700 mt-1">Catatan: {w.notes}</div>}
      </div>
      {w.rework.length > 0 && <span className="text-xs px-2 py-1 rounded-full bg-rose-50 text-rose-700" data-testid={`flow-rework-${w.wo_code}`}>Rework {w.rework.length}x · beban tambahan</span>}
    </div>
    {w.images.length > 0 && <div className="mt-2"><Thumbs paths={w.images} /></div>}
    {w.rework.length > 0 && <div className="mt-2 text-[11px] text-slate-500">{w.rework.map((r, i) => <div key={i}>{r.at?.slice(0, 10)} · {r.stage} → {r.action}: {r.note}</div>)}</div>}
    <div className="mt-3">{children}</div>
  </div>
);

export const Denied = () => <div className="p-6 text-sm text-slate-500" data-testid="flow-denied">Anda bukan anggota tim dashboard ini. Atur di Pengaturan → Akun & Roles → Tim per Dashboard.</div>;
